import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '5rem',
    overflow: 'hidden',
  },
  table: { width: 'max(100%, 110rem)' },
  tableBody: {
    boxSizing: 'border-box',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      width: '8rem',
    },
    '&:nth-child(2)': {
      width: '5rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  quantity: { textAlign: 'end', fontSize: '1.6rem', lineHeight: '1.8rem' },
  dropdownColumn: { paddingLeft: '2rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
